import axios from './api'

export function counselorLogin(loginDetails) {
	return axios.put('/counseling/counselor/login', loginDetails)
}

export function counselorSignUp(singupDetails) {
	return axios.put('/counseling/counser', singupDetails)
}

/**
 * Public Counselor login pre-auth check.
 * POST /public/user/counselor-auth-methods
 */
export function getCounselorAuthMethods(email) {
	return axios.post('/public/user/counselor-auth-methods', { email })
}
